

// @mui material components
import Icon from "@mui/material/Icon";
import { styled } from "@mui/material/styles";
// @ts-ignore 
export default styled(Icon)(({ theme, ownerState }) => {
  const { typography } = theme;
  const { size } = ownerState;
// @ts-ignore 
  const { fontWeightBold, size: fontSize } = typography;

  return {
    fontWeight: fontWeightBold,
    fontSize: size === "medium" && `${fontSize.md} !important`,
  };
});
